// ----------------------------------------------------------------------------
// Section: BV Reviews
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------

// Style includes
import './_bv-reviews.scss';

// -------------------------------------
// Scroll-to-reviews with sticky header offset
// -------------------------------------

function getHeaderHeight() {
  var header = document.querySelector('#shopify-section-header');
  return header ? header.offsetHeight : 0;
}
function scrollToReviews() {
  var target = document.querySelector('#BVRRContainer');
  if (!target) return;
  var top = target.getBoundingClientRect().top + window.scrollY - getHeaderHeight();
  window.scrollTo({
    top,
    behavior: 'smooth'
  });
}
function interceptReviewClicks() {
  document.addEventListener('click', e => {
    var ratingBtn = e.target.closest('.bv_main_rating_button');
    if (!ratingBtn) return;
    e.preventDefault();
    e.stopPropagation();
    scrollToReviews();
  }, true);
}
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', interceptReviewClicks);
} else {
  interceptReviewClicks();
}